module.exports = __webpack_public_path__ + "static/media/LogoToolbar.d8ff12bf.png";